import {Component, OnInit, ViewChild} from '@angular/core';
import { HlrContextService } from '../../services/hlr-context.service';
import { PaginationComponent } from '../../../../../shared/components/pagination/pagination.component';
import {ModalService} from 'ngx-dynamic-modal';
import {EditHlrContextComponent} from '../../modals/edit-hlr-context/edit-hlr-context.component';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-hlr-context',
  templateUrl: './hlr-context.component.html',
  styleUrls: ['./hlr-context.component.scss']
})
export class HlrContextComponent implements OnInit {

    enabled: boolean = false;
    contexts: Array<Object> = [];

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 5;

    @ViewChild(PaginationComponent) pagination: PaginationComponent;

    constructor(private hlrHandler: HlrContextService, private modalHandler: ModalService, private alertHandler: AlertaService) { }

    goToPage(n: number) {
        this.startAt = this.pagination.getStart();
        this.endAt = this.pagination.getEnd();
    }

    haveToPaginate(): boolean {
        return this.perPage < this.contexts.length;
    }

    modalCallback(res: Object): void {
        this.getHlrContexts();
    }

    newHlrContext(): void {
        this.modalHandler.addDynamicComponent(EditHlrContextComponent, {'type' :'new'}, (res) => {
            this.modalCallback(res);
        });
    }

    editHlrContext(row: Object): void {
        this.modalHandler.addDynamicComponent(EditHlrContextComponent, {'type' : 'edit', 'object' : row}, (res) => {
            this.modalCallback(res)
        });
    }

    deleteContext(row: Object): void {
        this.enabled = true;
        this.hlrHandler.deleteContext(row['pk']).subscribe(
            (result) => {
                let idx = this.contexts.findIndex((o) => {
                    return o['pk'] == row['pk'];
                });

                this.contexts.splice(idx, 1);
                this.enabled = false;
                this.alertHandler.addAlert('success', 'Context with name ' + row['name'] + ' has been removed successfully');
            }
        )
    }

    ngOnInit() {
        this.getHlrContexts();
    }

    protected getHlrContexts(): void {
        this.enabled = true;
        this.hlrHandler.getContexts().subscribe(
            (result) => {
                this.contexts = result;
                this.endAt = (!this.haveToPaginate()) ? this.contexts.length : this.perPage;
                this.enabled = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/hlr/components/hlr-context/hlr-context.component.ts